/* Ayurvedic Wholesale – storefront features: quick add, cart upsell, frequently bought together,
   recently viewed, category context for breadcrumbs. No external libraries. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fmt = function (paise) {
    var r = (paise / 100);
    return '₹' + r.toLocaleString('en-IN', { minimumFractionDigits: r % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  /* One discount rule for the whole site (same as snippets/aw-pct.liquid):
     round((MRP - price) / MRP x 100), 1-100, nothing when MRP/price is missing or price >= MRP */
  var pct = function (c, p) {
    c = +c || 0; p = +p || 0;
    if (c <= 0 || p <= 0 || p >= c) return 0;
    var r = Math.round((c - p) * 100 / c); return r > 100 ? 100 : r;
  };
  var priceHTML = function (p, c, from) {
    var o = pct(c, p);
    return (from ? 'From ' : '') + fmt(p) + (o ? ' <span class="aw-mrpl"><span class="visually-hidden">Regular price</span>MRP <s>' + fmt(c) + '</s></span> <span class="aw-pct">' + o + '% OFF</span>' : '');
  };
  /* Same variant choice as snippets/aw-dv.liquid: lowest-priced available variant */
  var dvOf = function (p) {
    var vs = (p && p.variants) || [], a = vs.filter(function (v) { return v.available; }), pool = a.length ? a : vs;
    return pool.reduce(function (m, v) { return !m || v.price < m.price ? v : m; }, null);
  };
  window.awPct = pct; window.awFmt = fmt; window.awPriceHTML = priceHTML;
  var ls = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- Add to cart (refreshes Dawn's cart drawer) ---------- */
  function addItems(items, btn) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items, sections_url: location.pathname };
    if (window.awCartSections) body.sections = window.awCartSections();
    else if (drawer && drawer.getSectionsToRender) body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) throw new Error(res.description || res.message || 'Could not add');
        if (window.awTrack) try { window.awTrack('add_to_cart', { items: items.length, src: btn && btn.dataset.awTrack }); } catch (e) {}
        var payload = res.items ? Object.assign({}, res.items[res.items.length - 1], { sections: res.sections }) : res;
        if (window.awRenderCart && res.sections) {
          window.awRenderCart(payload);
          if (typeof window.publish === 'function') try { window.publish('cart-update', { source: 'aw-add', cartData: payload }); } catch (e) {}
        }
        else if (drawer && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(payload); }
        else { location.href = root + 'cart'; }
      })
      .catch(function (e) { alertBox(btn, e.message); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; } });
  }
  function alertBox(btn, msg) {
    if (!btn) return; var p = document.createElement('p'); p.className = 'aw-err'; p.textContent = msg;
    btn.insertAdjacentElement('afterend', p); setTimeout(function () { p.remove(); }, 4000);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-aw-add]'); if (!b) return;
    e.preventDefault(); addItems([{ id: +b.dataset.awAdd, quantity: 1 }], b);
  });

  /* ---------- Recommendations API ---------- */
  var recCache = {};
  function recs(pid, intent, limit) {
    var k = pid + intent + limit; if (recCache[k]) return recCache[k];
    return (recCache[k] = fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=' + limit + '&intent=' + intent)
      .then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) { return (j.products || []).filter(function (p) { return p.featured_image; }); }).catch(function () { return []; }));
  }
  function img(src, w) { if (!src) return ''; if (src.indexOf('width=') > -1) return src; return src.replace(/(\.\w+)(\?|$)/, '_' + w + 'x$1$2'); }
  function firstAvail(p) { return (p.variants || []).filter(function (v) { return v.available; })[0]; }
  function miniCard(p) {
    var v = firstAvail(p) ? dvOf(p) : null; var price = v ? v.price : p.price;
    return '<div class="aw-mp"><a class="aw-mp__img" href="' + esc(p.url) + '">' + (p.featured_image ? '<img loading="lazy" src="' + esc(img(p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image, 300)) + '" alt="' + esc(p.title) + '" width="300" height="300">' : '') +
      '</a><a class="aw-mp__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a><p class="aw-mp__p">' + priceHTML(price, v && v.compare_at_price, p.price_varies) + '</p>' +
      (v ? '<button type="button" class="aw-mp__add" data-aw-add="' + v.id + '" data-aw-track="upsell_add">Add</button>' : '<span class="aw-mp__out">Out of stock</span>') + '</div>';
  }

  /* ---------- Cart upsell: "You may also add" ---------- */
  function fillUpsell(box) {
    if (!box || box.dataset.done === box.dataset.pid + box.dataset.in) return;
    box.dataset.done = box.dataset.pid + box.dataset.in;
    var inCart = (box.dataset.in || '').split(',').filter(Boolean).map(Number);
    var left = +box.dataset.left || 0;
    // Same health-concern (else form/brand) category as the cart item first, then Shopify recommendations
    var rel = box.dataset.h ? fetch(root + 'products/' + box.dataset.h + '?view=aw-rel').then(function (r) { return r.ok ? r.json() : { p: [] }; }).then(function (j) { return (j.p || []).filter(function (p) { return p && p.featured_image; }); }).catch(function () { return []; }) : Promise.resolve([]);
    Promise.all([rel, recs(box.dataset.pid, 'complementary', 4), recs(box.dataset.pid, 'related', 8)]).then(function (r) {
      var seen = {}, ok = function (p) { if (seen[p.id] || inCart.indexOf(p.id) > -1 || !firstAvail(p)) return false; return (seen[p.id] = 1); };
      var same = r[0].filter(ok);
      if (left > 0) same.sort(function (a, b) { return Math.abs(a.price - left) - Math.abs(b.price - left); }); // close the free-delivery gap first
      var list = same.concat(r[1].concat(r[2]).filter(ok));
      list = list.slice(0, 4); if (!list.length) return;
      box.querySelector('.aw-up__list').innerHTML = list.map(miniCard).join('');
      box.hidden = false;
    });
  }
  function scanUpsell() { document.querySelectorAll('.aw-up').forEach(fillUpsell); }
  document.addEventListener('DOMContentLoaded', scanUpsell);
  new MutationObserver(function () { scanUpsell(); }).observe(document.documentElement, { childList: true, subtree: true });


  /* ---------- Cart drawer + cart page: free-shipping bar and "You may also add" ---------- */
  var FS_TH = 49900, FS_FEE = 4900; // display only: free shipping from Rs 499, otherwise Rs 49 (set real rates in Shopify)
  function barHTML(cart) {
    var t = cart.total_price, left = FS_TH - t, pct = Math.min(100, Math.round(t * 100 / FS_TH));
    var msg = !cart.item_count ? 'Free shipping on orders of <strong>' + fmt(FS_TH) + '</strong> or more'
      : left > 0 ? 'Add <strong>' + fmt(left) + '</strong> more for <strong>FREE shipping</strong> <span>(otherwise ' + fmt(FS_FEE) + ')</span>'
      : '<span aria-hidden="true">🌿</span> You’ve unlocked <strong>FREE shipping</strong>';
    return '<div class="aw-fs' + (left <= 0 && cart.item_count ? ' is-done' : '') + '" role="status"><p class="aw-fs__t">' + msg + '</p><div class="aw-fs__bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div></div>';
  }
  function upHTML(cart) {
    if (!cart.item_count) return '';
    var ids = cart.items.map(function (i) { return i.product_id; }).join(',');
    return '<div class="aw-up" data-pid="' + cart.items[0].product_id + '" data-h="' + esc(cart.items[0].handle) + '" data-in="' + ids + '" data-left="' + (FS_TH - cart.total_price) + '" hidden><p class="aw-up__h">Often bought for the same need</p><div class="aw-up__list"></div></div>';
  }
  var cartBusy = false;
  function cartExtras(force) {
    var inner = document.querySelector('cart-drawer .drawer__inner');
    var page = document.getElementById('main-cart-items');
    var needDrawer = inner && (force || !inner.querySelector('.aw-fs'));
    var needPage = page && (force || !document.querySelector('.aw-fs--page'));
    if ((!needDrawer && !needPage) || cartBusy) return;
    cartBusy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      if (inner) {
        inner.querySelectorAll('.aw-fs, .aw-up').forEach(function (n) { n.remove(); });
        var head = inner.querySelector('.drawer__header');
        if (head) head.insertAdjacentHTML('afterend', barHTML(cart));
        var foot = inner.querySelector('.drawer__footer');
        if (foot) foot.insertAdjacentHTML('beforebegin', upHTML(cart));
      }
      if (page) {
        document.querySelectorAll('.aw-fs--page, .aw-up--page').forEach(function (n) { n.remove(); });
        var form = page.closest('form') || page;
        form.insertAdjacentHTML('beforebegin', barHTML(cart).replace('class="aw-fs', 'class="aw-fs aw-fs--page'));
        form.insertAdjacentHTML('afterend', upHTML(cart).replace('class="aw-up"', 'class="aw-up aw-up--page"'));
      }
      scanUpsell();
    }).catch(function () {}).finally(function () { cartBusy = false; });
  }
  document.addEventListener('DOMContentLoaded', function () { cartExtras(true); });
  new MutationObserver(function () { cartExtras(false); }).observe(document.documentElement, { childList: true, subtree: true });
  if (typeof window.subscribe === 'function') { try { window.subscribe('cart-update', function () { setTimeout(function () { cartExtras(true); }, 300); }); } catch (e) {} }

  /* ---------- Product page: recently viewed + frequently bought together ---------- */
  function productPage() {
    var P = window.awProduct; if (!P) return;
    var rv = ls.get('aw_rv', []).filter(function (x) { return x.h !== P.h && x.i; });
    var rvBox = document.getElementById('aw-rv');
    if (rvBox && rv.length) {
      rvBox.querySelector('.aw-mp-grid').innerHTML = rv.slice(0, 8).map(function (x) {
        return '<div class="aw-mp"><a class="aw-mp__img" href="' + esc(x.u) + '">' + (x.i ? '<img loading="lazy" src="' + esc(x.i) + '" alt="' + esc(x.t) + '" width="300" height="300">' : '') + '</a><a class="aw-mp__t" href="' + esc(x.u) + '">' + esc(x.t) + '</a><p class="aw-mp__p">' + priceHTML(x.p, x.c, x.f) + '</p>' + (x.a ? '<button type="button" class="aw-mp__add" data-aw-add="' + x.v + '" data-aw-track="rv_add">Add</button>' : '') + '</div>';
      }).join('');
      rvBox.hidden = false;
    }
    rv.unshift({ h: P.h, t: P.t, u: P.u, i: P.i, p: P.p, c: P.c, f: P.f, v: P.v, a: P.a }); ls.set('aw_rv', rv.slice(0, 12));

    var fbt = document.getElementById('aw-fbt'); if (!fbt || !P.a) return;
    Promise.all([recs(P.id, 'complementary', 4), recs(P.id, 'related', 6)]).then(function (r) {
      var seen = {}; seen[P.id] = 1;
      var list = r[0].concat(r[1]).filter(function (p) { if (seen[p.id] || !firstAvail(p)) return false; return (seen[p.id] = 1); }).slice(0, 2);
      if (!list.length) return;
      var all = [{ id: P.id, title: P.t, url: P.u, img: P.i, price: P.p, cmp: P.c, vid: P.v, me: true }].concat(list.map(function (p) {
        var v = dvOf(p); return { id: p.id, title: p.title, url: p.url, img: p.featured_image ? img(p.featured_image, 300) : '', price: v.price, cmp: v.compare_at_price, vid: v.id };
      }));
      var row = fbt.querySelector('.aw-fbt__row');
      row.innerHTML = all.map(function (x, i) {
        return (i ? '<span class="aw-fbt__plus" aria-hidden="true">+</span>' : '') + '<label class="aw-fbt__item"><input type="checkbox" checked value="' + x.vid + '" data-price="' + x.price + '" data-cmp="' + (x.cmp > x.price ? x.cmp : x.price) + '"><span class="aw-fbt__img">' + (x.img ? '<img loading="lazy" src="' + esc(x.img) + '" alt="" width="150" height="150">' : '') + '</span><span class="aw-fbt__t">' + (x.me ? '<em>This item:</em> ' : '') + (x.me ? esc(x.title) : '<a href="' + esc(x.url) + '">' + esc(x.title) + '</a>') + '</span><span class="aw-fbt__p">' + priceHTML(x.price, x.cmp) + '</span></label>';
      }).join('');
      var total = fbt.querySelector('.aw-fbt__total'), btn = fbt.querySelector('.aw-fbt__add');
      function upd() {
        var sel = [].slice.call(row.querySelectorAll('input:checked'));
        var tp = sel.reduce(function (s, c) { return s + +c.dataset.price; }, 0), tm = sel.reduce(function (s, c) { return s + +c.dataset.cmp; }, 0), tq = pct(tm, tp);
        total.innerHTML = 'Total for ' + sel.length + ' item' + (sel.length === 1 ? '' : 's') + ': <strong>' + fmt(tp) + '</strong>' + (tq ? ' <span class="aw-mrpl">MRP <s>' + fmt(tm) + '</s></span> <span class="aw-pct">' + tq + '% OFF</span>' : '');
        btn.disabled = !sel.length;
      }
      row.addEventListener('change', upd); upd();
      btn.addEventListener('click', function () {
        addItems([].slice.call(row.querySelectorAll('input:checked')).map(function (c) { return { id: +c.value, quantity: 1 }; }), btn);
      });
      fbt.hidden = false;
    });
  }

  /* ---------- Remember the category the shopper came from (product breadcrumb) ---------- */
  function collectionContext() {
    var m = location.pathname.match(/\/collections\/([^\/?#]+)\/?$/); if (!m || m[1] === 'all') return;
    var h1 = document.querySelector('.aw-ch__title, h1');
    try { sessionStorage.setItem('aw_col', JSON.stringify({ h: m[1], t: h1 ? h1.textContent.trim() : m[1] })); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { productPage(); collectionContext(); });
  else { productPage(); collectionContext(); }

  /* ---------- Phone numbers: plain text +91 70096 23687 → WhatsApp chat link ---------- */
  var PH = /(\+91[\s-]?)?70096[\s-]?23687/;
  function linkPhones(rootEl) {
    var w = document.createTreeWalker(rootEl || document.body, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      if (!PH.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
      var p = n.parentNode; while (p && p !== document.body) { if (/^(A|BUTTON|SCRIPT|STYLE|TEXTAREA|INPUT|SELECT|TITLE)$/.test(p.nodeName)) return NodeFilter.FILTER_REJECT; p = p.parentNode; }
      return NodeFilter.FILTER_ACCEPT; } });
    var nodes = []; while (w.nextNode()) nodes.push(w.currentNode);
    nodes.forEach(function (n) {
      var m = n.nodeValue.match(PH); if (!m) return;
      var after = n.splitText(m.index); after.splitText(m[0].length);
      var a = document.createElement('a'); a.href = 'https://wa.me/917009623687'; a.target = '_blank'; a.rel = 'noopener'; a.className = 'aw-tel'; a.setAttribute('data-aw-track', 'whatsapp'); a.textContent = after.nodeValue;
      after.parentNode.replaceChild(a, after);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { linkPhones(document.body); });

  /* ---------- Cart trust row (drawer + cart page) ---------- */
  var TRUST = '<ul class="aw-trustrow" role="list"><li><span aria-hidden="true">🔒</span> Secure checkout</li><li><span aria-hidden="true">✓</span> Genuine sealed packs</li><li><span aria-hidden="true">🚚</span> Free delivery ₹499+</li><li><span aria-hidden="true">🧾</span> GST-registered seller</li></ul>';
  function addTrust() {
    document.querySelectorAll('cart-drawer .drawer__footer, .cart__footer .cart__ctas').forEach(function (el) {
      if (el.querySelector('.aw-trustrow') || (el.nextElementSibling && el.nextElementSibling.classList.contains('aw-trustrow'))) return;
      el.insertAdjacentHTML(el.classList.contains('cart__ctas') ? 'afterend' : 'beforeend', TRUST);
    });
  }
  document.addEventListener('DOMContentLoaded', addTrust);
  new MutationObserver(addTrust).observe(document.documentElement, { childList: true, subtree: true });
})();

/* AW: hide any product tile whose image fails to load */
document.addEventListener('error', function (e) {
  var t = e.target; if (!t || t.tagName !== 'IMG') return;
  var box = t.closest('.grid__item, .slider__slide, .aw-rel li, .aw-mp, .aw-fd__card');
  if (box && !box.closest('.product__media-list, .product-media-modal')) box.style.display = 'none';
}, true);
